import { Routes, Route } from "react-router-dom";
import Navbar from "./Navbar";
import Home from "./views/Home";
import Live from "./views/Live";
import Statistics from "./views/Statistics";
import Results from "./views/Results";
import NBA from "./views/NBA";
import MLB from "./views/MLB";
import NFL from "./views/NFL";
import NHL from "./views/NHL";
import NCAAF from "./views/NCAAF";
import NCAAM from "./views/NCAAM";

function App() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/live" element={<Live />} />
        <Route path="/statistics" element={<Statistics />} />
        <Route path="/results" element={<Results />} />
        <Route path="/nba" element={<NBA />} />
        <Route path="/mlb" element={<MLB />} />
        <Route path="/nfl" element={<NFL />} />
        <Route path="/nhl" element={<NHL />} />
        <Route path="/ncaaf" element={<NCAAF />} />
        <Route path="/ncaam" element={<NCAAM />} />
      </Routes>
    </div>
  );
}

export default App;
